export default "__VITE_ASSET__BQtbun4E__"